/*global define*/

define("collections/Vessel", [
    'underscore',
    'backbone',
    'models/Vessel'
], function (_, Backbone, VesselModel) {
    'use strict';

    var VesselCollection = Backbone.Collection.extend({
        model: VesselModel
    });

    return VesselCollection;
});
